// extracted by mini-css-extract-plugin
export var quillEditor = "_nv-1";
export var variable = "_nv-0";